import * as d3 from 'd3';
import React from 'react';
import VoxelText from '../../../components/voxel/Text/VoxelText';

export interface UsageMetricProps {
  title: string;
  value: number;
  limit?: number;
  decimals?: number;
  blocked?: boolean;
  onLimitWarning?: boolean;
}

export const UsageMetric: React.FC<UsageMetricProps> = ({
  title,
  value,
  limit,
  decimals,
  blocked,
  onLimitWarning,
}) => {
  const numberFormatter1 = d3.format('.1s');
  const numberFormatter2 = d3.format('.2s');
  const noLimit = limit === undefined || limit === 0;
  const onLimit = limit !== undefined && value != undefined && value === limit;
  const overLimit = limit !== undefined && value != undefined && value > limit;
  const showWarning = blocked || overLimit;
  const share = limit != undefined && value != undefined ? Math.min(value / limit, 1) : 0;

  return (
    <div className="w-full flex flex-row justify-between items-center gap-4">
      <VoxelText variant="bread-normal" userSelectClass="select-none">
        {title}
      </VoxelText>
      {limit != undefined && (
        <div className="h-2 w-36 bg-gray-200 rounded-full">
          <div
            className={`
                h-2
                ${!showWarning && !(onLimit && onLimitWarning) && !noLimit ? 'bg-success-600/80' : ''}
                ${onLimit && onLimitWarning ? 'bg-warning-500' : ''}
                ${showWarning ? 'bg-error-500/70' : ''}
                rounded-full
            `}
            style={{ width: `${share * 100}%` }}
          />
        </div>
      )}
      <VoxelText variant="bread-normal" className="whitespace-nowrap">
        {value < 10 ? numberFormatter1(value) : numberFormatter2(value)}
        {limit === undefined
          ? ''
          : limit < 10
            ? ` / ${numberFormatter1(limit)}`
            : ` / ${numberFormatter2(limit)}`}
      </VoxelText>
    </div>
  );
};

export default UsageMetric;
